import Search from 'Components/Search'
import User from 'EurestoClass/User'
import moment from 'moment'
import React from 'react'
import SearchResa from './Resa'



moment.locale('fr')

class DatagridContact extends React.Component {

  render() {
    return <Search limit={this.props.limit || 20} all raz={true} defaultSearch={this.props.defaultSearch}
      path={'restaurant'}
      {...(this.props.searchProps || {})}
      requete={'reservation'}
      search={this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchResa type={this.props.type} />
    </Search>
  }

}

export default DatagridContact




// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/Search/index.js